"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
exports.ApolloContext = react_1.default.createContext
    ? react_1.default.createContext(undefined)
    : null;
//# sourceMappingURL=ApolloContext.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-apollo/ApolloContext.js
// module id = 479
// module chunks = 2